export default [
  {
    path: '/financial-settings',
    name: 'financial-settings',
    component: () => import('@/views/financial/FinancialSettings.vue'),
    meta: { 
      title: 'financial.settingsTitle',
      requiresAuth: true,
      requiredPerm: 'financial_settings.update'
    }
  },
  {
    path: '/financial-statements',
    name: 'financial.statements',
    component: () => import('@/views/financial/FinancialStatements.vue'),
    meta: { 
      title: 'financial.statementsTitle',
      requiresAuth: true,
      requiresFinance: true,
      requiredPerm: 'financial_statements.display'
    }
  }
];
